import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation('home');

  const checks = [
    'trust.check_1',
    'trust.check_2',
    'trust.check_3',
    'trust.check_4',
    'trust.check_5',
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-main">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-600 uppercase tracking-wider mb-2">
              <i className="ri-shield-check-line" />
              {t('trust.subtitle')}
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('trust.title')}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              {t('trust.desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {/* Checklist */}
            <div className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-4">
                {t('trust.checklist_title')}
              </h3>
              <ul className="space-y-3">
                {checks.map((key, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-accent-100 text-accent-600 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-xs" />
                    </span>
                    <span className="text-sm text-foreground-700">{t(key)}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Safety image + CTA */}
            <div className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
              <div className="aspect-[4/3] relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20padlock%20and%20shield%20icons%20on%20minimal%20background%2C%20clean%20white%20and%20cream%20tones%2C%20warm%20natural%20lighting%2C%20digital%20security%20theme%2C%20editorial%20illustration%20style%2C%20soft%20beige%20palette%2C%20professional%20aesthetic&width=600&height=450&seq=trust-safety-001&orientation=landscape"
                  alt="Safety verification"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <a
                    href="/safety"
                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-white text-sm font-medium text-foreground-900 hover:bg-white/90 transition-colors"
                  >
                    {t('trust.read_more')}
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}